/*
  Note:
  Append custom message for `zh-tw` follow error list (https://joi.dev/api/?v=17.2.1#list-of-errors)
*/

const customizeFormErrorMessage = {
  'any.required': '必填內容',
  'string.base': '必填內容',
  'string.empty': '必填文字',
  'string.min': '文字長度必須大於 {{#limit}} 個字',
  'string.max': '文字長度必須小於 {{#limit}} 個字',
  'string.length': '文字長度必須是 {{#limit}} 個字',
  'number.base': '必需是數字',
  'number.integer': '必需是數字',
  'number.min': '必需大於 {{#limit}}',
  'number.max': '必需小於 {{#limit}}',
  'number.unsafe': '必需是數字',
  'string.email': '電子郵件格式有誤',
};

export default customizeFormErrorMessage;
